import { Button, Card, Collapse, Spin, Table } from 'antd';
import { useEffect, useState } from 'react';
import OrganizationCollapseView from '../../components/Organizations/OrganizationCollapseView';
import { RightOutlined, UnderlineOutlined } from '@ant-design/icons';
import { HospiceOrganizationWithDetailsResponse } from '../../models/OrganizationModels';
import Title from 'antd/lib/skeleton/Title';
import RoundedButton from '../../components/RoundedButton';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { UserWithDetailsDto } from '../../models/UserResponses';
import PageTitle from '../../components/PageTitle';
import OrganizationView from '../../components/Organizations/OrganizationView';
import { Utility } from '../../utilities/Utility';
import {
    useGetOrganizationsQuery,
    useGetOrganizationUsersQuery,
} from '../../features/organization/organizationService';
import '../../styles/_orgs.scss';
const { Panel } = Collapse;

const OrganizationUsersView = () => {
    const { id } = useParams();
    const organizationId: string = id ?? '';

    const location = useLocation();
    const { data: organizations, isLoading: organizationLoading } =
        useGetOrganizationsQuery({});
    const { data: users, isLoading: usersLoading } =
        useGetOrganizationUsersQuery(organizationId);

    const navigate = useNavigate();

    const renderTeam = (teams: string[]) => {
        if (teams && teams.length > 0) {
            return teams.map((team: string, index: number) => (
                <div>
                    {team}
                    {team === teams.at(-1) ? '' : ','}
                </div>
            ));
        }

        return <div>N/A</div>;
    };

    const columns = [
        {
            title: 'User Status',
            dataIndex: 'userStatus',
            key: 'userStatus',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${record.isActive ? 'Active' : 'Inactive'}`}</div>
            ),
        },
        {
            title: 'Admin',
            dataIndex: 'admin',
            key: 'admin',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${record.scriptSureUserAdminLevelDisplay}`}</div>
            ),
        },
        {
            title: 'Permission',
            dataIndex: 'permission',
            key: 'permission',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${record.scriptSureUserPermissionDisplay}`}</div>
            ),
        },
        {
            title: 'User Type',
            dataIndex: 'userType',
            key: 'userType',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${record.scriptSureUserType}`}</div>
            ),
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${record.firstName}`}</div>
            ),
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${record.lastName}`}</div>
            ),
        },
        {
            title: 'Team/Practice',
            dataIndex: 'teamPractice',
            key: 'teamPractice',
            render: (key: string, record: UserWithDetailsDto) =>
                renderTeam(record.teams),
        },
        {
            title: 'NPI#',
            dataIndex: 'npi',
            key: 'npi',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${Utility.getStringOrNa(record.npi)}`}</div>
            ),
        },
        {
            title: 'DEA#',
            dataIndex: 'dea',
            key: 'dea',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${Utility.getStringOrNa(record.dea)}`}</div>
            ),
        },
        {
            title: 'State License #',
            dataIndex: 'stateLicense',
            key: 'stateLicense',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>{`${Utility.getStringOrNa(record.stateLicense)}`}</div>
            ),
        },
        {
            title: 'Actions',
            key: 'action',
            render: (key: string, record: UserWithDetailsDto) => (
                <div>
                    <RightOutlined
                        onClick={() => {
                            navigate(`${record.id}/update`);
                        }}
                        rev={undefined}
                    />
                </div>
            ),
        },
    ];

    return (
        <Spin spinning={organizationLoading || usersLoading}>
            <PageTitle title="Manage Users" onClick={() => navigate(-1)} />
            <div className="p-5">
                {location.state != undefined ? (
                    <OrganizationView organization={location.state!} />
                ) : (
                    organizations && (
                        <OrganizationView
                            organization={
                                organizations?.filter(
                                    (n) => n.id === organizationId,
                                )[0]
                            }
                        />
                    )
                )}
                <div className="mt-5">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div className="fs-4 fw-semibold">User List</div>
                        <RoundedButton
                            className="bg-light-blue text-white pt-2 pb-2 ps-4 pe-4 h-25 w-10 fs-6"
                            onClick={() => navigate(`import`)}
                        >
                            Import New User
                        </RoundedButton>
                    </div>
                    {users && (
                        <Table
                            columns={columns}
                            dataSource={users!}
                            pagination={{ pageSize: 6 }}
                            className="table-user-list"
                        />
                    )}
                </div>
            </div>
        </Spin>
    );
};

export default OrganizationUsersView;
